<template>
	<div class="equiplist">
		<el-dialog class='gstdia' :close-on-click-modal='false' :close-on-press-escape='false' width='80%'
			:title="etitle" :visible.sync="showDia" @close='closeDia'>
			<div style="margin: -10px 10px 0 10px;" v-loading='loading' class=''>
				<el-row :gutter="20" class=''>
					<el-col :span='8'>
						<el-button size='small' type="primary" icon="" :disabled="sRows1.length == 0"
							@click='batchBindEquip'>{{ $t('add_selected') }}</el-button>
						<el-button v-if='config.type == 2' size='small' type="primary" icon="" @click='bindAll'>{{ $t('add_all') }}
						</el-button>
						<el-button v-if='isImport' size='small' type="" icon="" @click='ImportEquip'>{{ $t('app_batch_import') }}</el-button>
						<!-- <el-button @click='batchDel' :disabled="sRows.length == 0" size='small' type='danger' plain>批量删除</el-button>     -->
					</el-col>
					<span v-if='config.type == 2'>
						<el-col :span='8'>
							<div class="glineflex">
								<label class="glinelb">{{ $t('terminal.app_distributor') }}：</label>
								<Merchant :config='sortMc'></Merchant>
							</div>
						</el-col>
						<el-col :span='8'>
							<div class="glineflex">
								<label class="glinelb">{{ $t('terminal.device_id') }}：</label>
								<el-input @keyup.enter.native="srcEq" v-model='eid' size='small' placeholder="">
								</el-input>
							</div>
						</el-col>
					</span>
					<span v-else>
						<el-col :span='8' v-if='config.type != 0'>
							<div class="glineflex">
								<label class="glinelb">{{ $t('terminal.app_distributor') }}：</label>
								<Merchant :config='sortMc'></Merchant>
							</div>
						</el-col>
						<el-col :offset="config.type == 0?8:0" :span='8'>
							<div class="glineflex">
								<label class="glinelb">{{ $t('terminal.search_device') }}：</label>
								<el-input @keyup.enter.native="srcEq" v-model='eid' size='small' placeholder="">
								</el-input>
							</div>
						</el-col>
					</span>
				</el-row>
				<!--  @row-click='rowClick' -->
				<el-table ref="multipleTable" class='gtbtop' tooltip-effect="dark" :data="tableData1"
					@selection-change="batchSelected1" style="width: 100%">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="deviceid" :label="$t('terminal.device_sn')" width="">
					</el-table-column>
					<el-table-column prop="devicename" :label="$t('terminal.device_name')" width="">
					</el-table-column>
					<el-table-column prop="productName" :label="$t('terminal.device_model')">
					</el-table-column>
					<el-table-column prop="terminalVersion" :label="$t('terminal.device_type')">
					</el-table-column>
					<el-table-column prop="createTime" :label="$t('app_update_time')" width="160">
					</el-table-column>
					<el-table-column prop="name" :label="$t('app_operation')" width="86">
						<template slot-scope="scope">
							<el-button type='text' @click='bindEquip(scope.row)'>{{ $t('app_add')}}</el-button>
							<!-- <el-button type='text' @click='editRow(scope.row)'>编辑</el-button>
              <label class='opbline'>|</label>
              <el-button @click='delRow(scope.row.id)' type='text' class='opdcolor'>删除</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				<Pages class='gpages' :cpage='page1' :ctotal="total1" :config='pconfig'></Pages>
			</div>
		</el-dialog>

		<ImportEquip :config='iconfig'></ImportEquip>
	</div>
</template>

<script>
	import Pages from '@/components/Pages.vue'
	import Merchant from '@/components/Merchant.vue'
	import ImportEquip from '@/components/ImportEquip.vue'
	// import Model from '@/components/Model.vue'
	export default {
		data() {
			return {
				mech: '',
				mcvl: '',
				sortMc: {},
				showDia: false,
				isImport: false,
				eid: '',
				eqtype: '',
				page1: 1,
				total1: 0,
				tableData1: [],
				sRows1: [],
				loading: false,
				pconfig: {},
				iconfig: {}
			}
		},
		computed: {
			etitle() {
				if (!this.config) return ''
				return this.config.title ? this.config.title : this.$t('terminal.add_device_task')
			}
		},
		components: {
			Pages,
			Merchant,
			ImportEquip
		},
		/////////// config.type 0商户 1渠道商 2升级
		props: ['config', 'show'],
		watch: {
			show(n) {
				this.tableData1 = []
				this.total1 = 0

				this.showDia = n
				if (n) {
					///// open
					// console.log('open')
					// alert('open')
				} else {
					//// close        
					this.config.callback('')
					this.closeDia()
				}
			},
			config(n) {
				this.tableData1 = []
				this.total1 = 0

				this.eqtype = n.eqtype
				this.getEquip()
				this.isImport = n.isImport
			}
		},
		methods: {
			ImportEquip() {
				var _this = this
				this.iconfig = {
					type: 2, //// 0.equipement 1.merchant 2.upgradedetail
					agid: '',
					tid: this.config.tid,
					showDia: true,
					callback: () => {
						_this.getEquip()
						// _this.config.callback('')         
						// _this.closeDia()   
					}
				}
			},
			bindAll() {
				if (this.config.bindall) {
					this.config.bindall(this.eqtype, this.eid, this.mcvl)
				}
			},
			srcEq() {
				this.page1 = 1
				this.getEquip()
			},
			closeDia() {
				this.show = false
				this.showDia = false
				this.mcvl = ''
				this.modelId = ''
				var _this = this
				this.sortMc = {
					size: 'small',
					value: '',
					callback: (vl) => {
						_this.mcvl = vl ? vl : ''
						_this.getEquip()
					}
				}
				this.$refs.multipleTable.clearSelection()
			},
			bindEquip(row) {
				// this.bindRqs(row.deviceid)
				if (this.config.callback) {
					this.config.callback(row.deviceid)
					this.closeDia()
				}
			},
			batchSelected1(val) {
				this.sRows1 = val
			},
			batchBindEquip() {
				var arr = []
				this.sRows1.forEach(item => {
					arr.push(item.deviceid)
				})
				//////
				// this.bindRqs(arr.toString())
				if (this.config.callback) {
					this.config.callback(arr.toString())
					this.closeDia()
				}
			},
			getEquip() {
				this.loading = 1
				var deviceId = this.eid ? this.eid : ''
				var agentId = this.config.agid ? this.config.agid : ''
				var mcId = this.config.mcid ? this.config.mcid : ''
				var status = ''
				var mcsearch = this.mcvl
				var terType = this.eqtype
				this.$terList(this.page1, this.$gRow, deviceId,'', '', agentId, mcId, mcsearch, status, terType, '','', '','', 0,
					res => {
						this.loading = 0
						if (res.status == 200) {
							this.tableData1 = res.data
							this.total1 = res.total
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = 0
					})
			}
		},
		mounted() {

			// this.$refs.multipleTable.clearSelection()

			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page1 = page
					_this.getEquip()
				}
			}

			this.sortMc = {
				size: 'small',
				value: '',
				callback: (vl) => {
					_this.mcvl = vl ? vl : ''
					_this.getEquip()
				}
			}


		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.merchantctrl {
		width: 100%;
	}
</style>
